import type { TrailerType } from '@shared/api-types.js';

export interface TrailerTypeOption {
  value: TrailerType;
  label: string;
  emoji: string;
  description: string;
}

export const TRAILER_TYPES: TrailerTypeOption[] = [
  { value: 'utility', label: 'Utility', emoji: '🛻', description: 'Open utility / cargo' },
  { value: 'dump', label: 'Dump', emoji: '🪨', description: 'Hydraulic dump bed' },
  { value: 'enclosed', label: 'Enclosed', emoji: '📦', description: 'Lockable enclosed cargo' },
  { value: 'car_hauler', label: 'Car hauler', emoji: '🚗', description: 'Cars, ATVs, project vehicles' },
  { value: 'flatbed', label: 'Flatbed', emoji: '🏗️', description: 'Open deck for lumber, skids' },
  { value: 'landscape', label: 'Landscape', emoji: '🌿', description: 'Mesh sides + ramp gate' },
  { value: 'snowmobile', label: 'Snowmobile', emoji: '❄️', description: 'Sled transport' },
  { value: 'motorcycle', label: 'Motorcycle', emoji: '🏍️', description: 'Bikes, dirt bikes' },
  { value: 'boat', label: 'Boat', emoji: '🛥️', description: 'Boat trailer' },
  { value: 'rv', label: 'RV / camper', emoji: '🚐', description: 'Travel trailer / RV' },
  { value: 'horse', label: 'Horse', emoji: '🐴', description: 'Livestock / horse' },
  { value: 'other', label: 'Other', emoji: '🔧', description: 'Something else' },
];

export const TRAILER_TYPE_MAP: Record<TrailerType, TrailerTypeOption> = Object.fromEntries(
  TRAILER_TYPES.map((t) => [t.value, t]),
) as Record<TrailerType, TrailerTypeOption>;
